import { render } from "./PipedriveFrame.vue?vue&type=template&id=33c83727&scoped=true"
import script from "./PipedriveFrame.vue?vue&type=script&lang=js"
export * from "./PipedriveFrame.vue?vue&type=script&lang=js"

import "./PipedriveFrame.vue?vue&type=style&index=0&id=33c83727&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c83727"]])

export default __exports__